<template>
    <report-list-item :text="text" :checked="checked" :disabled="disabled" @report-status-change="handleReportStatusChanged">
        <template v-if="showMFComprehensive && checked">
            <mds-checkbox v-model="includeMFComprehensive" class="report-item__checkbox-mf">MF Comprehensive</mds-checkbox>
        </template>
    </report-list-item>
</template>
<script>
import MdsCheckbox from "@mds/checkbox";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import ReportListItem from "./ReportListItem";
import * as types from "../../store/mutation-types";

export default {
    name: "investment-details-report",
    props: {
        text: {
            type: String,
            default: ""
        },
        checked: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        reportSettings: {
            type: Object
        }
    },
    components: {
        MdsCheckbox,
        ReportListItem
    },
    mixins: [MwcSharedMixin],
    computed: {
        includeMFComprehensive: {
            get() {
                return this.reportSettings.includeMFComprehensive;
            },
            set(value) {
                this.$store.commit(`reportSetting/${types.SET_INCLUDE_MF_COMPREHENSIVE}`, value);
            }
        },
        showMFComprehensive() {
            return this.$store.getters["config/showMFComprehensive"];
        }
    },
    methods: {
        handleReportStatusChanged(e) {
            this.$emit("report-status-change", e);
        }
    }
};
</script>

<style lang="scss" scoped>
.report-item__checkbox-mf.mds-checkbox___hypo {
    padding: $mds-space-2-x;
    ::v-deep span.mds-checkbox__visible-wrap___hypo {
        margin-left: $mds-space-4-x;
    }
}
</style>
